import { useState } from 'react'

export type LinkShareState = 'default' | 'ready' | 'stale'
export type LinkSharePhase = 'none' | 'shared'

export const deriveLinkShareState = (phase: LinkSharePhase, isStale: boolean): LinkShareState => {
  if (phase === 'none') {
    return 'default'
  }
  return isStale ? 'stale' : 'ready'
}

export interface LinkShareActions {
  state: LinkShareState
  onLinkShared: () => void
}

export const useLinkShareState = (isStale: boolean): LinkShareActions => {
  const [phase, setPhase] = useState<LinkSharePhase>('none')
  return {
    state: deriveLinkShareState(phase, isStale),
    onLinkShared: () => setPhase('shared'),
  }
}
